import { useEffect } from "react";
import Card from './Controls/Card'
import AOS from 'aos';
import "aos/dist/aos.css";
import './css/tailwind.css'
import './App.css'
import './fonts/BentonSans-Regular.otf'
import './fonts/BentonSans-Medium.otf'

function App() {

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <main className="max-h-full flex items-center justify-center">
      <div>
        <Card></Card>
      </div>
    </main>
  );
}

export default App;
